import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import { Query } from "_shared/_api/queries/query";
import { FeeScheduleTemplateOrderParameters } from "work/fee-schedule-templates/_api/queries/contracts/ordering/fee-schedule-template-order-parameters";
import { FeeScheduleTemplateFilterParameters } from "work/fee-schedule-templates/_api/queries/contracts/filtering/fee-schedule-template-filter-parameters";

export default class FeeScheduleTemplateQuery extends Query<
  FeeScheduleTemplateFilterParameters,
  FeeScheduleTemplateOrderParameters,
  PaginationParameters
> {
  public constructor(params: {
    filterParameters: FeeScheduleTemplateFilterParameters;
    orderParameters: FeeScheduleTemplateOrderParameters;
    paginationParameters: PaginationParameters;
  }) {
    super(params);
  }

  isEqualTo(other: FeeScheduleTemplateQuery): boolean {
    if (!other || !(other instanceof FeeScheduleTemplateQuery)) {
      return false;
    }
    return (
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }
}
